// @flow
import ApiClient from 'common/services/api';
import { CentralMarket } from '../domain/CentralMarket';

class CentralMarketService {

  async fetchCentralMarkets(callSign: string): Promise<CentralMarket[]> {
    const url = `/central-markets/${callSign}`;

    const { data } = await ApiClient.get(url);

    return data.map(datum => CentralMarket.parse(datum));
  }
}

export default new CentralMarketService();



// WEBPACK FOOTER //
// ./src/statsradio/modules/centralMarkets/services/CentralMarketService.js